(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {
      // Your custom options
    });

    // Маска на телефон
    $("input[name*=-phone]").mask("+9 (999) 999-9999");

    // анимация лейблов форм
    if (isExist(".form-wrapper")) {
      const forms = document.querySelectorAll(".form-wrapper");

      forms.forEach((form) => {
        const inputs = form.querySelectorAll("input, textarea");
        inputs.forEach((input) => {
          input.onfocus = function (e) {
            const label = input.closest("label");
            label.classList.add("active");
          };
          input.onblur = function (e) {
            const label = input.closest("label");
            label.classList.remove("active");
          };
        });
      });
    }

    // Оборачиваем изображения в ссылки
    if (isExist(".container-text .wp-block-image")) {
      let wpImage = document.querySelectorAll(
        ".container-text .wp-block-image",
      );

      wpImage.forEach((image) => {
        const imgElement = image.querySelector("img"),
          figcaptionElement = image.querySelector("figcaption"),
          src = imgElement.src;

        if (!image.parentElement.classList.contains("wp-block-gallery")) {
          if (imgElement && figcaptionElement) {
            let org_html = image.innerHTML;

            org_html = org_html.replace(
              /<figcaption\b[^>]*>.*?<\/figcaption>/i,
              "",
            );

            image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>${figcaptionElement.outerHTML}`;
          } else {
            const org_html = image.innerHTML;
            image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>`;
          }
        }
      });
    }

    // Галереи на дефолтной странице
    if (isExist(".container-text .wp-block-gallery")) {
      let wpGalleries = document.querySelectorAll(
        ".container-text .wp-block-gallery",
      );

      wpGalleries.forEach((gallery, index) => {
        let wpImages = gallery.querySelectorAll(".wp-block-image");
        let minHeight = Number.MAX_SAFE_INTEGER;

        wpImages.forEach((image) => {
          const imgElement = image.querySelector("img"),
            figcaptionElement = image.querySelector("figcaption"),
            src = imgElement.src;

          if (imgElement && figcaptionElement) {
            let org_html = image.innerHTML;

            org_html = org_html.replace(
              /<figcaption\b[^>]*>.*?<\/figcaption>/i,
              "",
            );

            image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>${figcaptionElement.outerHTML}`;
          } else {
            const org_html = image.innerHTML;
            image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>`;
          }

          // Добавление проверки изображений на высоту и присваивания всем минимальной высоты
          const height = image.offsetHeight;

          if (height < minHeight) {
            minHeight = height;
          }
        });

        wpImages.forEach((img) => {
          img.style.height = `${minHeight}px`;
        });
      });
    }

    // валидация форм
    let forms = document.querySelectorAll(".wpcf7");

    for (let form of forms) {
      form.addEventListener("wpcf7mailsent", function () {
        Fancybox.close();
        Fancybox.show([{ src: "#success-popup", type: "inline" }]);
      });

      form.addEventListener("wpcf7mailfailed", function () {
        Fancybox.close();
        Fancybox.show([{ src: "#failed-popup", type: "inline" }]);
      });
    }

    sal({
      threshold: 0.1,
    });

    if (isExist("#yandex-map")) {
      lazyLoadMap();
    }
  });
})(jQuery);

// Яндекс Карты ленивая загрузка скрипта
function loadMapScript() {
  var apiKey = "327d605b-8fc3-4bad-af02-db4bd8d31e2c",
    lang = "ru_RU",
    script = document.createElement("script");

  script.src =
    "https://api-maps.yandex.ru/2.1/?apikey=" + apiKey + "&lang=" + lang;
  script.type = "text/javascript";
  script.onload = function () {
    ymaps.ready(function () {
      iniMap();
    });
  };

  document.body.appendChild(script);
}

// Яндекс Карты создание карты
function iniMap() {
  var mapElement = document.getElementById("yandex-map");
  var logoUrl = "";
  var points = [];
  var placemarks = [];
  var activePlacemark = null;
  var mapInstance = null;
  var pinLayout = null;
  var pointIndex = 0;
  var placemark = null;

  if (!mapElement) {
    return;
  }

  logoUrl = mapElement.getAttribute("data-logo") || "";

  try {
    points = JSON.parse(mapElement.getAttribute("data-points") || "[]");
  } catch (parseError) {
    points = [];
  }

  if (!points.length) {
    return;
  }

  mapInstance = new ymaps.Map("yandex-map", {
    center: points[0].coords || [48.480239, 135.07191],
    zoom: 13,
    controls: ["zoomControl"],
  });

  pinLayout = ymaps.templateLayoutFactory.createClass(
    '<div class="ymaps-pin{% if properties.active %} ymaps-pin_active{% endif %}">' +
      '<div class="ymaps-pin__card">' +
      '<img class="ymaps-pin__logo" src="' +
      logoUrl +
      '" alt="Habara">' +
      '<div class="ymaps-pin__info">' +
      '<div class="ymaps-pin__address">$[properties.address]</div>' +
      '<div class="ymaps-pin__schedule">$[properties.schedule]</div>' +
      "</div>" +
      "</div>" +
      '<div class="ymaps-pin__tail"></div>' +
      "</div>",
    {
      build: function () {
        pinLayout.superclass.build.call(this);
        this._rebuildMetrics();
      },
      _rebuildMetrics: function () {
        var parentNode = this.getParentElement();
        var pinNode = parentNode
          ? parentNode.querySelector(".ymaps-pin")
          : null;
        var pinWidth = 0;
        var pinHeight = 0;
        var halfWidth = 0;

        this._pinNode = pinNode;

        if (!pinNode) {
          return;
        }

        pinWidth = pinNode.offsetWidth;
        pinHeight = pinNode.offsetHeight;

        if (!pinWidth || !pinHeight) {
          return;
        }

        halfWidth = Math.round(pinWidth / 2);
        // Shape учитывает CSS transform: translate(-50%, -100%)
        this._pinSize = [pinWidth, pinHeight];
        this._pinShape = [
          [-halfWidth, -pinHeight],
          [halfWidth, 0],
        ];
        this.events.fire("shapechange");
      },
      getShape: function () {
        if (!this._pinShape) {
          this._rebuildMetrics();
        }

        if (!this._pinShape) {
          return null;
        }

        return new ymaps.shape.Rectangle(
          new ymaps.geometry.pixel.Rectangle(this._pinShape),
        );
      },
    },
  );

  function applyActiveState(nextActive) {
    var markIndex = 0;
    var currentMark = null;

    if (activePlacemark === nextActive) {
      nextActive.properties.set("active", false);
      activePlacemark = null;
      return;
    }

    for (markIndex = 0; markIndex < placemarks.length; markIndex++) {
      currentMark = placemarks[markIndex];
      currentMark.properties.set("active", currentMark === nextActive);
    }

    activePlacemark = nextActive;
  }

  function onPlacemarkClick(event) {
    applyActiveState(event.get("target"));
  }

  for (pointIndex = 0; pointIndex < points.length; pointIndex++) {
    if (!points[pointIndex].coords || points[pointIndex].coords.length !== 2) {
      continue;
    }

    placemark = new ymaps.Placemark(
      points[pointIndex].coords,
      {
        address: points[pointIndex].address || "",
        schedule: points[pointIndex].schedule || "",
        active: false,
      },
      {
        iconLayout: pinLayout,
        iconOffset: [0, 0],
        hasBalloon: false,
        hideIconOnBalloonOpen: false,
        cursor: "pointer",
      },
    );

    placemark.events.add("click", onPlacemarkClick);
    placemarks.push(placemark);
    mapInstance.geoObjects.add(placemark);
  }

  if (placemarks.length > 1) {
    mapInstance.setBounds(mapInstance.geoObjects.getBounds(), {
      checkZoomRange: true,
      zoomMargin: 60,
    });
  } else if (placemarks.length === 1) {
    mapInstance.setCenter(points[0].coords, 14);
  }
}

// Яндекс Карты инициализация при прокрутке
function lazyLoadMap() {
  var mapContainer = document.getElementById("yandex-map"),
    observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

  if (!mapContainer) {
    return;
  }

  var intersectionObserver = new IntersectionObserver(function (
    entries,
    observer,
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        loadMapScript();
      }
    });
  }, observerOptions);

  intersectionObserver.observe(mapContainer);
}
